<template lang="pug">
Container(@loaded="afterload" :itemId="fileId")
    a-tabs
        a-tab-pane(key="1" tab="折线图")
            a-row 
                a-col(:md="12" :sm="24")
                    a-divider(type="horizontal") 复利
                    v-chart(:option="compoundOption" :autoresize="true" style="width: 100%; height: 800px")
                a-col(:md="12" :sm="24")
                    a-divider(type="horizontal") 单利
                    v-chart(:option="simpleOption" :autoresize="true" style="width: 100%; height: 800px")

            
        a-tab-pane(key="2" tab="表格")
            a-row
                a-col(:md="12" :sm="24")
                    a-divider(type="horizontal") 复利
                    a-table(:columns="columns" 
                        size="small"
                        rowKey="date"
                        :dataSource="compound_data" 
                        :pagination="{ pageSize: 20, showSizeChanger: true }" 
                        :loading="loading")
                a-col(:md="12" :sm="24")
                    a-divider(type="horizontal") 单利

                    a-table(:columns="columns" 
                        size="small"
                        rowKey="date"
                        :dataSource="simple_data" 
                        :pagination="{ pageSize: 20, showSizeChanger: true }" 
                        :loading="loading")

</template>

<script>
import Container from './Container.vue'
import JSZip from 'jszip';
import VChart, {THEME_KEY} from 'vue-echarts';
import registerEchartsComponents from './registerEcharts.js';
import axios from 'axios';
const host = '/api/fs';

export default {
    props: ['fileId'],
    data() {
        return {
            id: '',
            name: '',
            columns: [],
            compound_data: [],
            simple_data: [],
            alphaCols: [],
            loading: false,
        }
    },
    mounted() {
        registerEchartsComponents();
        // this.load();
    },
    methods: {
        afterload(info) {
            this.id = info.id;
            this.name = info.name;
            this.load();
        },
        async load() {
            this.loading = true;
            let res = await axios.get(`${host}/download/${this.id}`, {
                ...this.$api.jwtHeader(),
                responseType: 'blob',
            });

            let zip = await JSZip.loadAsync(res.data);
            let compound_file = zip.file('pnl_compound_interest.csv');
            let simple_file = zip.file('pnl_simple_interest.csv');
            let compound_data = await compound_file.async('string');
            let simple_data = await simple_file.async('string');

            this.compound_data =  this.str2CSV(compound_data);
            this.simple_data =  this.str2CSV(simple_data);
            this.loading = false;
        },
        str2CSV(str) {
            let data = str.trim().split('\n');
            let header = data[0].split(',');
            this.columns = header.map(h => {
                return {
                    title: h,
                    dataIndex: h,
                    key: h,
                }
            });
            // this.haveAlpha = data[0].includes('alpha');
            this.alphaCols = header.filter(h => h.includes('alpha'));
            let rows = [];
            for (let i = 1; i < data.length; i++) {
                let row = data[i].split(',');
                let obj = {};
                for (let j = 0; j < header.length; j++) {
                    if (header[j] == 'date') {
                        obj[header[j]] = row[j];
                    } else
                        obj[header[j]] = Number(row[j]);
                    }                
                rows.push(obj);
            }
            return rows;
        },
        getOption(items) {
            
            let series = [
                {
                    type: 'line',
                    name: 'pnl',
                    gridIndex: 0,
                    encode: {
                        x: 'date',
                        y: 'pnl'
                    }
                },
                {
                    type: 'line',
                    name: 'pnl_after_fee',
                    gridIndex: 0,
                    encode: {
                        x: 'date',
                        y: 'pnl_after_fee'
                    }
                },
                {
                    type: 'line',
                    name: 'drawdown',
                    gridIndex: 1,
                    yAxisIndex: 1,
                    xAxisIndex: 1,
                    encode: {
                        x: 'date',
                        y: 'drawdown'
                    }
                },
                {
                    type: 'line',
                    name: 'drawdown_after_fee',
                    gridIndex: 1,
                    yAxisIndex: 1,
                    xAxisIndex: 1,
                    encode: {
                        x: 'date',
                        y: 'drawdown_after_fee'
                    }
                },
            ];
            
            this.alphaCols.map((col, i) => {
                series.push( {
                    name: col,
                    type: 'line',
                    gridIndex: 2,
                    xAxisIndex: 2,
                    yAxisIndex: 2,
                    encode: {
                        x: 'date',
                        y: col
                    }
                });
            });

            return {
                dataset: {
                    source: items,
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                legend: {
                    data: ['pnl', 'pnl_after_fee', 'drawdown', 'drawdown_after_fee']
                },
                axisPointer: {
                    link: [
                    {
                        xAxisIndex: 'all'
                    }
                    ]
                },
                grid: [
                    {
                        top: '5%',      // 距离顶部15%
                        height: '28%',   // 高度30%
                        left: '8%',      // 距离左侧8%（与下方grid对齐）
                        right: '8%',     // 距离右侧8%（与下方grid对齐）
                        containLabel: true // 包含坐标轴标签，避免标签被截断
                    },
                    // 第二个grid（下方）
                    {
                        top: '35%',      // 距离顶部55%（与上方grid间隔10%）
                        height: '28%',   // 高度30%
                        left: '8%',      // 与上方grid左对齐
                        right: '8%',     // 与上方grid右对齐
                        containLabel: true
                    },
                    {
                        top: '65%',      // 距离顶部55%（与上方grid间隔10%）
                        height: '28%',   // 高度30%
                        left: '8%',      // 与上方grid左对齐
                        right: '8%',     // 与上方grid右对齐
                        containLabel: true
                    }
                ],
                dataZoom: [{
                    type: 'inside',
                    zoomOnMouseWheel: true,
                    moveOnMouseMove: true,
                    moveOnMouseWheel: false,
                    xAxisIndex: [0, 1, 2]
                }],
                xAxis: [
                    {
                        type: 'category',
                        gridIndex: 0,
                    },
                    {
                        type: 'category',
                        gridIndex: 1,
                        show: true,
                        // show: this.alphaCols.length == 0,
                    },

                    {
                        type: 'category',
                        gridIndex: 2,
                    },

                ],
                yAxis: [
                    {
                        scale: true,
                        type: 'value',
                        gridIndex: 0,
                    },
                    {
                        scale: true,
                        type: 'value',
                        gridIndex: 1,
                    },
                    {
                        scale: true,
                        type: 'value',
                        gridIndex: 2,
                    },
                ],
                series
            }
        }
        
    },
    computed: {
        compoundOption(){
            return this.getOption(this.compound_data);
        },
        simpleOption() {
            return this.getOption(this.simple_data);
        }
    },
    components: {
        VChart,
        Container
    }
}
</script>

<style lang="less" scoped>

</style>
